import yolorekt_logo_stacked from 'assets/logo/yolorekt_logo-stacked-SOLID-FFFFFF_430x243.png'
import yolorekt_logo_inline from 'assets/logo/yolorekt_logo_inline_FFF_134x25.png'
import futures_logo from 'assets/logo/futures_logo.svg'
import powered_by_yolorekt_white from 'assets/logo/powered_by_yolorekt-white.svg'
import yolorekt_moon_white from 'assets/logo/yolorekt_moon-white.svg'
import wsb_logo_neon from 'assets/logo/wsb_logo_master.png'
import yolo_hilo_icon from 'assets/icons/yolo_hilo_icon.svg'
import telegram_logo from 'assets/logo/telegram_logo.svg'
import yolobot_logo_2 from 'assets/logo/yolobot_logo_2.svg'
import yolorekt_logo_stacked_SOLID_FFFFFF from 'assets/logo/yolorekt_logo-stacked-SOLID-FFFFFF.svg'
import yolobot_icon from 'assets/logo/yolobot_icon.svg'
import yolo_token_full_logo_2 from 'assets/logo/yolo_token_full_logo_2.svg'

export const logos = {
  yolorekt_logo_stacked,
  yolorekt_logo_inline,
  powered_by_yolorekt_white,
  yolorekt_moon_white,
  futures_logo,
  wsb_logo_neon,
  yolo_hilo_icon,
  telegram_logo,
  yolobot_logo_2,
  yolorekt_logo_stacked_SOLID_FFFFFF,
  yolobot_icon,
  yolo_token_full_logo_2,
}
